import { PLATFORM_SESSION_HEADER, platformSessionContext } from "@lawline/shared/access/platform";

type PageSession = Parameters<typeof platformSessionContext>[0];

export function createPageSession() {
	let bound: PageSession | undefined;
	let stale = false;
	const listeners = new Set<() => void>();
	const invalidate = () => {
		if (stale) return;
		stale = true;
		for (const listener of listeners) listener();
	};
	return {
		observe(session: PageSession | null) {
			if (!bound && session) bound = { ...session };
			else if (
				bound &&
				(!session || platformSessionContext(session) !== platformSessionContext(bound))
			)
				invalidate();
		},
		headers(): Record<string, string> {
			return bound ? { [PLATFORM_SESSION_HEADER]: platformSessionContext(bound) } : {};
		},
		afterTenantExitHeaders(): Record<string, string> {
			if (!bound) throw new Error("Page session is required");
			// Better Auth clears the active organization after a confirmed exit.
			return {
				[PLATFORM_SESSION_HEADER]: platformSessionContext({ ...bound, activeOrganizationId: null }),
			};
		},
		invalidate,
		isStale: () => stale,
		subscribe(listener: () => void) {
			listeners.add(listener);
			return () => {
				listeners.delete(listener);
			};
		},
	};
}

export const pageSession = createPageSession();
